/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import AuthLayout from '../auth-layout'
import IconExchange from 'custom/assets/landing/exchange.svg'
import IconLocation from 'custom/assets/landing/Location.svg'
import IconLoan from 'custom/assets/landing/Loan_Landing.svg'
import IconContactUs from 'custom/assets/landing/contactUs.svg'
import NeoButton from '../../../components/NeoButton/NeoButton'
import BtnAppleStore from 'custom/assets/landing/btnAppleStore.svg'
import BtnGooglePlay from 'custom/assets/landing/btnGooglePlay.svg'
import { useTranslation } from 'react-i18next'
import { LANDING_KEYS, AUTH_KEYS, SIDENAV_KEYS } from '../../../utils/translation-constants'
import config from 'custom/config/feature.config.json'
import { setMenuList } from '../../../actions'
import { useDispatch } from 'react-redux'

import envConfig from 'custom/config/environment'

const menuData = config['LANDING']

export default function Landing() {
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <AuthLayout>
      <div>
        <div className='mt-3'>
          <div className='mx-auto' style={{ width: '320px' }}>
            <h1 className='text-center' style={{ color: '#313131' }}>
              {t(LANDING_KEYS.HI)} <br /> {t(AUTH_KEYS.GET_STARTED_KEYS.TITLE)} <br />
              {t(LANDING_KEYS.INTERNET)}{' '}
              <span className='font-weight-bold'>{t(LANDING_KEYS.BANKING)}</span>
            </h1>
            {/* <p className='text-center small mt-3'>
            {t(LANDING_KEYS.DESC)}
            </p> */}
          </div>
          <div
            className='d-flex justify-content-around my-5'
            style={{ width: '370px', margin: '0 auto' }}>
            {menuData['exchangeRate'] && (
              <div className='text-center'>
                <Link to='/landing/exchangeRates' className='text-dark'>
                  <img className='' src={IconExchange} alt='exchange icon' width='56' height='48' />
                  <p className='font-weight-600 small mt-4'>{t(SIDENAV_KEYS.EXCHANGE_RATE)}</p>
                </Link>
              </div>
            )}
            {menuData['locateUs'] && (
              <div className='text-center'>
                <Link to='/landing/locateUs' className='text-dark'>
                  <img className='' src={IconLocation} alt='location icon' width='56' height='48' />
                  <p className='font-weight-600 small mt-4'>{t(LANDING_KEYS.LOCATE)}</p>
                </Link>
              </div>
            )}
            {menuData['loanEligibility'] && (
              <div className='text-center'>
                <Link to='/landing/calculator' className='text-dark'>
                  <img className='' src={IconLoan} alt='loan icon' width='56' height='48' />
                  <p className='font-weight-600 small mt-4'>{t(LANDING_KEYS.LOAN_ELIGIBLITY)}</p>
                </Link>
              </div>
            )}

            {menuData['contactUs'] && (
              <div className='text-center'>
                <Link to='/landing/contactUs' className='text-dark'>
                  <img className='' src={IconContactUs} alt='loan icon' width='56' height='48' />
                  <p className='font-weight-600 small mt-4'>{t(LANDING_KEYS.CONTACT_US)}</p>
                </Link>
              </div>
            )}
          </div>

          <div className='text-center my-5'>
            <NeoButton
              type='submit'
              mode='newDesign'
              text={t(LANDING_KEYS.START)}
              onClick={() => {
                dispatch(setMenuList(menuData))
                history.push({
                  pathname: '/login',
                })
              }}
              styles={{ fontSize: 16, width: '312px' }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center'>
        {config['appStore'] && (
          <button
            type='button'
            onClick={() => window.open(envConfig.APP_IOS_LINK, '_blank')}
            className='btn btn-apple-store'>
            <img className='' src={BtnAppleStore} alt='Apple Store button' />
          </button>
        )}
        {config['playStore'] && (
          <button
            type='button'
            className='btn btn-play-store'
            onClick={() => window.open(envConfig.APP_ANDROID_LINK, '_blank')}>
            <img className='' src={BtnGooglePlay} alt='Play Store button' />
          </button>
        )}
      </div>
    </AuthLayout>
  )
}

// function renderLoading() {
//   return (
//     <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
//       <Loading width='50px' height='50px' />
//     </div>
//   )
// }
